import React, { Component, Fragment } from 'react'
import { LanguageConsumer, Translate } from '../../../contexts/LanguageContext';
import { Loading, BreadCrumb, Card, UserAccounts, Validator, VRules, VConditions, ErrorMessage } from '../../../components';
import { Rules, PaymentConfirm, Currencies, TransferOptionUrl } from '../../../components/Payment';
import { TransferOptionService } from '../../../services/TransferOptionService';
import { DepositService } from '../../../services/DepositService';

export class ZotaPay extends Component {

    constructor(props) {
        super(props)

        this.Refs = React.createRef();

        this.state = {
            loading: true,
            confirm: false,
            paymentOptions: {
                acceptedCurrencies: [],
                description: "",
                rules: [],
                title: ""
            },
            // Payment Form
            login: 0,
            amount: 0,
            currency: "",
            validation: {
                error: false,
                message: ""
            }
        }

    }
    componentWillMount() {
        TransferOptionService.Deposit.OptionPage(TransferOptionUrl()).then(response => {
            
            if (!response) {
                document.location.href = "/deposit";
                return false;
            }

            this.setState({
                paymentOptions: response,
                loading: false,
                currency: response.acceptedCurrencies[0],
                error: false
            })
        });
    }
    changeAccount(userAccount) {
        this.setState({
            login: userAccount.active
        });
    }
    onChangeForm(e, key) {

        this.setState({
            [key]: e.target.value
        });
    }
    onToggleDeposit() {
        if (this.isValid())
            this.setState(prevState => ({
                confirm: !prevState.confirm
            }));
    }
    isValid() {

        let minValue = 500;

        switch (this.state.currency) {
            case "MYR":
                minValue = 50;
                break;
            case "IDR":
                minValue = 200000;
                break;
            case "VND":
                minValue = 300000;
                break;
            default:
                minValue = 500;
                break;
        }

        VRules["amount"] = {
            Invalid: (value) => {
                return VConditions.Required(value) || VConditions.Min(value, minValue)
            },
            Message: Translate("Invalid Amount")
        }


        if (!this.state.confirm) {

            let error = Validator.Valid({ amount: this.state.amount }, this.Refs);

            this.setState({
                validation: error
            });

            return !error.error;
        }

        return true;

    }
    onConfirmDeposit() {
        this.setState({ loading: true }, () => {

            DepositService.ZotaPay({
                login: this.state.login,
                amount: this.state.amount,
                currency: this.state.currency
            }).then((response) => {

                if (response.error) {

                    this.setState({
                        validation: {
                            error: response.error,
                            message: response.message
                        },
                        loading: false
                    });
                }
            });
        });
    }
    render() {
        return (
            <LanguageConsumer>
                {() => (
                    <Fragment>
                        <Loading Show={this.state.loading} Title={Translate("Loading Content")} />
                        <BreadCrumb Title={this.state.paymentOptions.title} Name={this.state.paymentOptions.title} SubTitle={Translate("Deposit")} SubUrl="/deposit" />
                        <Card Title={this.state.paymentOptions.title} Description={this.state.paymentOptions.description} Logo={this.state.paymentOptions.logo}>
                            <div className="row">
                                <div className="col-md-12">
                                    <Rules Items={this.state.paymentOptions.rules} />
                                </div>
                                <div className={"col-md-12 " + (this.state.error ? "" : "d-none")}>
                                    <div className={"alert alert-danger alert-dismissible fade mb-0 show"} role="alert">
                                        <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                        <strong>Error !</strong> {this.state.errorMessage}
                                    </div>
                                </div>
                                <ErrorMessage Validation={this.state.validation} />
                                {!this.state.confirm ?
                                    <div className="col-md-12">
                                        <form className="form-horizontal" name="depositForm" ref={this.Refs}>
                                            <h4 className="mt-0 header-title m-b-20 mt-4 text-dark"><i className="fas fa-file-invoice"></i>{Translate("&nbsp; Payment Form")}</h4>
                                            <div className="form-group row ml-3">
                                                <label htmlFor="example-text-input" className="col-sm-2 col-form-label">{Translate(" Account")}</label>
                                                <div className="col-sm-5">
                                                    <UserAccounts List className="bg-dark" Change={(e, userAccount) => this.changeAccount(userAccount)} Status="deposit"/>
                                                </div>
                                            </div>
                                            <div className="form-group row ml-3">
                                                <label htmlFor="amount" className="col-sm-2 col-form-label">{Translate("Amount")}</label>
                                                <div className="col-sm-5">
                                                    <input className="form-control" type="number" id="amount" onChange={(e) => this.onChangeForm(e, "amount")} value={this.state.amount} onFocus={e => e.target.select()} />
                                                </div>
                                            </div>
                                            <div className="form-group row ml-3">
                                                <label htmlFor="currency" className="col-sm-2 col-form-label">{Translate("Currency")}</label>
                                                <div className="col-sm-5">
                                                    <Currencies Items={this.state.paymentOptions.acceptedCurrencies} onChange={(e) => this.onChangeForm(e, "currency")} />
                                                </div>
                                            </div>
                                            <div className="form-group row ml-3">
                                                <label htmlFor="example-text-input" className="col-sm-2 col-form-label"></label>
                                                <div className="col-sm-5">
                                                    <button type="button" className="btn btn-lg btn-success" onClick={(e) => this.onToggleDeposit()}>{Translate("Create a Deposit Request")}</button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                    :
                                    <PaymentConfirm Form={[
                                        {
                                            title: Translate("Account"),
                                            value: this.state.login
                                        },
                                        {
                                            title: Translate("Amount"),
                                            value: this.state.amount.format('C') + " " + this.state.currency
                                        },
                                        {
                                            title: Translate("Warning"),
                                            value: <label className="alert alert-warning font-12 p-3">{Translate('Please be aware that ARTSMRKTS is not responsible for an exchange rate used by payment service providers. No refund for exchange rate and related fees will be given. Do you wish to proceed?')}</label>,
                                        }
                                    ]} Cancel={(e) => this.onToggleDeposit()} Confirm={(e) => this.onConfirmDeposit()} />
                                }
                            </div>
                        </Card>
                    </Fragment>
                )}
            </LanguageConsumer>
        )
    }
}